import React, { useState, useEffect } from "react"
import axios from "axios";
import { CKYCUploadFileWithName } from "./CKYCUploadFileWithName";
import { baseUrl } from "../index";
const RelationOption = [
    { Key: "Father", Value: "FatherName" },
    { Key: "Mother", Value: "MotherName" },
    { Key: "Spouse", Value: "SpouseName" }
]
const DocTypeUpload = (props) => {
   // DocType
    //DocNumber
    const [Base64Photo, setBase64Photo] = useState("");
    const [Base64POI, setBase64POI] = useState("");
    const [Base64POA, setBase64POA] = useState("");
    const [selectedPOA, setSelectedPOA] = useState("");
    const [selectedPOI, setSelectedPOI] = useState("");
    const [selectedPOIValue, setSelectedPOIValue] = useState("");
    const [selectedPOAValue, setSelectedPOAValue] = useState("");
    const [Relation, setRelation] = useState("FatherName");
    const [RelationName, setRelationName] = useState("");
    useEffect(() => {
        setSelectedPOI(props.CKYCData.filter(row => row?.Name.match("PAN"))[0]?.Name);
        setSelectedPOA(props.CKYCData.filter(row => row?.Name.match("ADHAR"))[0]?.Name);
    }, []);
    //console.log(selectedPOI, "selectedPOI")
    //console.log(selectedPOA, "selectedPOA")

    const onSubmit = (e) => {
        e.preventDefault();
        if (props.Companyid === 118 && RelationName.trim() === "") {
            return alert(`Kindly Enter ${Relation} Name`);
        }
        const files = document.querySelectorAll("input[type=file]");
        const formData = new FormData();
        formData.append("insurerID", props.Companyid);
        formData.append("enquiryNo", props.EnquiryNo);
        formData.append("URL", "UploadCKYCFile");
        formData.append("uploadDesc", "PostedFiles");

        files.forEach((f) => {

            if (f.value !== "")
                formData.append(f.id.toLowerCase(), f.files[0]);

        });
        axios.post(`${baseUrl}/central/centralcall/UploadFile`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(res => {
                if (res.data.StatusCode === 200) {
                    props.setKYCDetails({
                        Base64Photo,
                        Base64POI,
                        Base64POA,
                        IsRedirectUrl:false,
                        IsUploadFile: true,
                        Relation: RelationName + "~" + Relation,
                        SelectedPOA: props.CKYCData.filter(row=>row.Name=== selectedPOA)[0].Code,
                        SelectedPOI: props.CKYCData.filter(row => row.Name === selectedPOI)[0].Code,
                        SelectedPOIValue: selectedPOIValue,
                        selectedPOAValue: selectedPOAValue
                    });
                   // props.onKYCSubmit();
                }else alert("Kindly Choose File");
            });
    }
    
    return <>
       
        <div className="modal fade AnuthorModal show" id="exampleModalDefault33" style={{ display:"block" }} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content CkycUploadDOC CkycUploadDOC002">
                    <div className="modal-header d-flex">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Upload Documents</h1>
                        <button className="CRoss" onClick={() => props.onKYCSubmit(false)}>X</button>
                    </div>
                    <div className="modal-body">
                      
                        <div id="fileBody" >
                            <form onSubmit={onSubmit}>
                                <CKYCUploadFileWithName DocumentTypeID={selectedPOI } setDocumentType={(data) => setSelectedPOI(data)}
                                    setDocumentID={(data) => setSelectedPOIValue(data)} DocumentIDValue={selectedPOIValue}
                                    setDocumentBase64={(data) => setBase64POI(data)} DocumentBase64={Base64POI } title="Identity" CKYCData={props.CKYCData} />
                                <CKYCUploadFileWithName DocumentTypeID={selectedPOA} setDocumentType={data => setSelectedPOA(data)}
                                    setDocumentID={data => setSelectedPOAValue(data)} DocumentIDValue={selectedPOAValue }
                                    setDocumentBase64={data => setBase64POA(data)} DocumentBase64={Base64POA}
                                    title="Address" CKYCData={props.CKYCData} />
                                {props.Companyid ===118 && <div className="row">
                                    <div className="col-md-6">
                                        <select className="packageForm" value={Relation} onChange={e => setRelation(e.target.value)}>
                                            {RelationOption.map((r,i) => <option key={ i} value={r.Value}>{r.Key}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <input className="packageForm" type="text" value={RelationName} onChange={e => setRelationName(e.target.value)} />
                                    </div>
                                </div>}
                                <button className="fileUploadBtn" disabled={Base64POA === "" || Base64POI===""}>Upload Document</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
export default DocTypeUpload;